import { AbstractDocumentsFacade } from '@pf/shared-services';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    IDocument,
    IDocumentCreate,
    IDocumentSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { ReceiptLineFilesService } from '@control-tower/platform-wms';

@Injectable()
export class ReceiptLinesDocumentsFacade extends AbstractDocumentsFacade {
    constructor() {
        const dataService = inject(ReceiptLineFilesService);

        super(PFWmsEntities.Exception, {
            create$: (
                entityId: string,
                document: IDocumentCreate,
                parentId?: string
            ) =>
                dataService.receiptLineFilePost({
                    receiptId: parentId as string,
                    lineId: entityId,
                    ...document,
                }) as Observable<IDocument>,
            delete$: (
                entityId: string,
                documentId: string,
                parentId?: string
            ) =>
                dataService.receiptLineFileDelete({
                    receiptId: parentId as string,
                    id: documentId,
                    lineId: entityId,
                }) as Observable<IDocument>,
            get$: (entityId: string, documentId: string, parentId?: string) =>
                dataService.receiptLineFileReadById({
                    receiptId: parentId as string,
                    id: documentId,
                    lineId: entityId,
                }) as Observable<IDocument>,
            search$: (
                entityId: string,
                params: IDocumentSearchParams,
                parentId?: string
            ) =>
                dataService.receiptLineFileSearch({
                    receiptId: parentId as string,
                    lineId: entityId,
                    ...params,
                }) as Observable<IPagedResult<IDocument>>,
            download$: (
                entityId: string,
                documentId: string,
                parentId?: string
            ) => {
                return dataService.receiptLineFileGet({
                    receiptId: parentId as string,
                    id: documentId,
                    lineId: entityId,
                }) as Observable<Blob>;
            },
        });
    }
}
